import React from 'react';
import PropTypes from 'prop-types';
import 'font-awesome/css/font-awesome.min.css';
import './TableInform.css';

const TableDashboardInform = ({
  dados,
  exibirExcluir = true,
  onExcluir,
}) => {
  const handleExcluir = (index) => {
    onExcluir(index);
  };
  return (
    <table className="tabela">
      <thead>
        <tr>
          <th>Nome do Dashboard</th>
          <th>Descrição</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        {dados.map((dashboard) => (
          <tr key={dashboard.id}>
            <td>{dashboard.dashboardName}</td>
            <td>{dashboard.dashboardDescription}</td>
            <td>
              {exibirExcluir && (
                <button
                  className="tabela-acao tabela-excluir"
                  onClick={() => handleExcluir(dashboard.id)}
                >
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TableDashboardInform.propTypes = {
  dados: PropTypes.arrayOf(
    PropTypes.shape({
      dashboardName: PropTypes.string.isRequired,
      dashboardDescription: PropTypes.string.isRequired,
    })
  ).isRequired,
  exibirExcluir: PropTypes.bool,  // Propriedade para exibir o ícone de excluir
  onExcluir: PropTypes.func.isRequired,
};

export default TableDashboardInform;
